export enum ErrorMessages {
  'required' = 'This field is required',
  'invalid_email' = 'Please enter a valid email',
}
